<template>
	<div
		:class="[
			disableQuill ? 'disableClass' : 'enableClass',
			designClass ? 'designQuill' : '', // will add only if passed
		]"
	>
		<quill-editor
			v-model="editorContent"
			:options="editorOption"
			:auto-focus="false"
			:disabled="disableQuill"
		>
		</quill-editor>
	</div>
</template>
<script>
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import { required, maxLength } from "vuelidate/lib/validators";
export default {
	name: "QuillEditor",
	components: {
		quillEditor,
	},
	props: {
		value: String,
		addquesProp: Boolean,
		disableQuill: Boolean,
		designClass: {
			// new prop
			type: Boolean, // can be string like "highlight" or ""
			default: false,
		},
	},
	validations: {
		editorContent: {
			required,
			maxLength: maxLength(1024),
		},
	},
	data() {
		return {
			editorContent: this.value,
			changeaddquesProp: this.addquesProp,
			editorOption: {
				// Customize your toolbar options here
				modules: {
					toolbar: [
						["bold", "italic", "underline"],
						[
							{
								list: "ordered",
							},
							{
								list: "bullet",
							},
						],
					],
				},
				preserveWhitespace: true, // Preserve consecutive spaces
				placeholder: " ",
			},
		};
	},
	watch: {
		value(oldvs) {
			this.editorContent = oldvs;
		},

		addquesProp(val) {
			if (val) {
				this.editorContent = "";
				this.$emit("validationVal", false);
			}
		},
		editorContent(newv) {
			const cleanedHtml = this.cleanQuillHtml(newv);
			this.editorContent = cleanedHtml;

			this.$emit("questionText", cleanedHtml);

			const plainText = this.convertIntotext(cleanedHtml);

			if (!plainText.trim()) {
				this.$emit("validationVal", true);
			} else {
				this.$emit("validationVal", false);
			}

			this.$emit("addquesBack", this.changeaddquesProp);
		},
	},
	mounted() {
		document.addEventListener("paste", this.handlePaste);
		const quill = this.$refs.editor?.quill;
		if (quill) {
			quill.keyboard.addBinding({ key: 13 }, () => {
				const text = quill.getText().trim();
				if (!text) return false; // block enter on empty editor
			});
		}
	},
	beforeDestroy() {
		document.removeEventListener("paste", this.handlePaste);
	},
	methods: {
		cleanQuillHtml(html) {
			if (!html) return "";

			return html
				.replace(/(<p><br><\/p>)+/g, "<p><br></p>") // collapse multiple enters
				.replace(/^<p><br><\/p>/, "") // remove leading empty line
				.replace(/<p><br><\/p>$/, ""); // remove trailing empty line
		},
		handlePaste(event) {
			const clipboardData = event.clipboardData || window.clipboardData;
			const items = clipboardData.items;

			for (const item of items) {
				if (item.type.includes("image") || item.type.includes("video")) {
					event.preventDefault();
					return;
				}
			}
		},

		updateContent() {
			this.$emit("input", this.editorContent);
		},

		convertIntotext(allText) {
			const parser = new DOMParser();
			const htmlDoc = parser.parseFromString(allText, "text/html");
			const convertedText = htmlDoc.body.textContent || "";
			return convertedText;
		},
	},
};
</script>
<style lang="scss">
.ql-editor {
	height: 280px;
	white-space: normal !important;
	font-size: 14px;
}
.disableClass {
	background-color: #b8b8b8;
	opacity: 0.3;
	color: #000000;
}
.enableClass {
	background-color: white !important;
	border-radius: 8px;
}
.quill-editor {
	border: 1px solid rgba(10, 86, 200, 0.5);
	box-shadow: inset 0px 0px 4px rgba(0, 0, 0, 0.1);
	border-radius: 3px;
}
.designQuill .quill-editor {
	border: 1px solid #d0d5dd;
	box-shadow: inset 0px 0px 4px rgba(0, 0, 0, 0.1);
	border-radius: 8px 8px 3px 3px;
}

.designQuill .ql-toolbar.ql-snow {
	border: 1px solid #ccc;
	box-sizing: border-box;
	font-family: "Helvetica Neue", "Helvetica", "Arial", sans-serif;
	padding: 8px;
	background-color: #f1f1f4;
	border-radius: 7px 7px 0px 0px;
}

.designQuill .ql-editor {
	height: 110px;
}
.designQuill .ql-container.ql-snow {
	border: none;
}
</style>
